import { render, staticRenderFns } from "./TopUpManagement.vue?vue&type=template&id=18fe80ef&scoped=true&"
import script from "./TopUpManagement.vue?vue&type=script&lang=js&"
export * from "./TopUpManagement.vue?vue&type=script&lang=js&"
import style0 from "./TopUpManagement.vue?vue&type=style&index=0&id=18fe80ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe80ef",
  null
  
)

export default component.exports